import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

interface UpdateGrowthIndicatorParams {
  indicators: [number, number];
}

export const useUpdateGrowthIndicator = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, UpdateGrowthIndicatorParams>({
    mutationFn: async ({ indicators }) => {
      const response = await httpService.post(
        API_CONFIG.path.updateGrowthIndicator,
        {
          indicators,
        }
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["growth-indicator"] });
    },
  });
};
